import { render, staticRenderFns } from "./CustomerCharts.vue?vue&type=template&id=f5ffbd70&scoped=true&"
import script from "./CustomerCharts.vue?vue&type=script&lang=js&"
export * from "./CustomerCharts.vue?vue&type=script&lang=js&"
import style0 from "./CustomerCharts.vue?vue&type=style&index=0&id=f5ffbd70&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ffbd70",
  null
  
)

export default component.exports